import { ISendMoneyPayload, IObject } from '../../utils/interface';
export const preparePayload = (props: Record<string, any>): ISendMoneyPayload => {
  const payload: ISendMoneyPayload = {
    gross_source_amount: props.gross_source_amount,
    net_of_fee_amount: props.net_of_fee_amount,
    net_source_amount: props.net_source_amount,
    destination_amount: props.destination_amount,
    fx_rate: props.fx_rate,
    instarem_fx_rate: props.instarem_fx_rate,
    margin_currency: props.margin_currency,
    margin_percent: props.margin_percent,
    margin_amount: props.margin_amount,
    transaction_fee_percent: props.transaction_fee_percent,
    transaction_fee_amount: props.transaction_fee_amount,
    tax_type_1: props.tax_type_1,
    tax_amount_1: props.tax_amount_1,
    tax_type_2: props.tax_type_2,
    tax_amount_2: props.tax_amount_2,
    tax_type_3: props.tax_type_3,
    tax_amount_3: props.tax_amount_3,
    net_tax_amount: props.net_tax_amount,
    additional_info: props?.additional_info,
    coupon_code: props.coupon_code,
    coupon_amount: props.coupon_amount,
    reporting_currency_info: props.reporting_currency_info,
    source_of_funds: null,
    reason_for_transfer: null,
    remittance_type: null,
    source_currency: '',
    destination_currency: '',
    remittance_type_code: ''
  };
  return payload;
};

export const getFirstValue = (list: IObject[]): number | null => {
  if (list?.length > 0) {
    return list[0]?.value;
  }
  return null;
};
